/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Event_Group_Options_Merge_By_Speakers_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to merge events: {error}" |
*
* @param {Event_Group_Options_Merge_By_Speakers_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_merge_by_speakers_failed = /** @type {((inputs: Event_Group_Options_Merge_By_Speakers_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Merge_By_Speakers_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec de la fusion des événements : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Zusammenführen der Ereignisse fehlgeschlagen: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile unire gli eventi: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось объединить события: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al fusionar eventos: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`事件合并失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`イベントのマージに失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`इवेंट्स को मर्ज करने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao mesclar eventos: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to merge events: ${i?.error}`)
});